module.exports = __webpack_public_path__ + "img/card-back2.3bf26d58.svg";